import { hpaCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

const hpaAvailabilityOptions = [{ title: 'HPA enabled', value: 'true' }];

export const HpaAvailabilityQuickSearch = () => {
  return (
    <QuickSearchFilter
      options={hpaAvailabilityOptions}
      criterion={hpaCriterion}
    />
  );
};
